import React from 'react'
import Avatar from '../../Common/Avatar/Avatar'
import MessageImageFileTransfer from './MessageImageFileTransfer'
import MessageFileTransfer from './MessageFileTransfer'

export class MessageAgentFileTransfer extends React.Component {
  render() {
    const { name, className, type, fileInfo } = this.props

    // HOCs?
    return (
      <React.Fragment>
        <Avatar type='agent' agentName={name} />
        <div>
          {type === 'imageTransfer' && (
            <div className={className('image')}>
              <MessageImageFileTransfer src={fileInfo.address} alt={name} />
            </div>
          )}

          {type === 'fileTransfer' && <MessageFileTransfer {...this.props} />}
        </div>
      </React.Fragment>
    )
  }
}

export default MessageAgentFileTransfer
